import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import { WEBHOOK } from '@eggplant/routing'
import type { GetWebhooksListResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: GetWebhooksListResponse) => ReactElement
  onSuccess: (webhooks: GetWebhooksListResponse) => void
}

const GetWebhooksRequest = ({
  children,
  onSuccess
}: Props) =>
  <AuthenticatedDataRequest
    children={children}
    method='get'
    onSuccess={onSuccess}
    url={`${NOTIFICATION_SERVICE}/${WEBHOOK}`}
  />

export default GetWebhooksRequest
